module.exports = __webpack_public_path__ + "static/media/logo.8f9b9394.png";